import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Space, Typography } from 'antd';
import AuthService from '../services/auth-service';

const { Title, Paragraph } = Typography;


function UserHomePage() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState<boolean>(false);
  
    return (
        <>
            <Title>User settings</Title>
        </>
    );
}

export default UserHomePage;